import React from "react";
import styled from "styled-components";
import { FloatingHeader, PenceToPounds, MatIcon } from "fiver-react-ui-components";
const StyledBalance = styled.div`
  flex: 2 0 auto;
`;
const StyledBalanceLabel = styled.div`
  font-size: 0.75rem;
  color: ${props => props.theme.colorLabel};
  margin-bottom: 0.175rem;
`;
const StyledBalanceValue = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${props => props.theme.colorSuccess};
`;
const StyledDepositButton = styled.div`
  flex: 0 0 auto;
`;
const StyledStatus = styled.div`
  display: flex;
  align-items: center;
`;
const StyledStatusBadge = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  margin: 0 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${p => p.isSuccess && `background: ${p.theme.colorSuccess}`};
  ${p => !p.isSuccess && `background: ${p.theme.colorDanger}`};

  & > span {
    color: white;
    font-size: 9px;
  }
`;
const StyledStatusText = styled.div`
  font-size: 0.75rem;
  ${p => !p.isSuccess && `color: ${p.theme.colorLabel}`};
`;

const WalletFloatingHeader = ({
  position,
  balance,
  isScrolledDown,
  phoneVerified,
  cardAdded
}) => /*#__PURE__*/React.createElement(FloatingHeader, {
  position: position,
  justifyContent: "space-between",
  isScrolledDown: isScrolledDown
}, /*#__PURE__*/React.createElement(StyledBalance, null, /*#__PURE__*/React.createElement(StyledBalanceLabel, null, "Balance"), /*#__PURE__*/React.createElement(StyledBalanceValue, null, "\xA3", /*#__PURE__*/React.createElement(PenceToPounds, null, balance))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledStatus, null, /*#__PURE__*/React.createElement(StyledStatusBadge, {
  isSuccess: phoneVerified
}, /*#__PURE__*/React.createElement(MatIcon, null, phoneVerified ? "check" : "close")), /*#__PURE__*/React.createElement(StyledStatusText, {
  isSuccess: phoneVerified
}, "Phone Verified"), /*#__PURE__*/React.createElement(StyledStatusBadge, {
  style: {
    marginLeft: "1.25rem"
  },
  isSuccess: cardAdded
}, /*#__PURE__*/React.createElement(MatIcon, null, cardAdded ? "check" : "close")), /*#__PURE__*/React.createElement(StyledStatusText, {
  isSuccess: cardAdded
}, "Card Added"))));

export default WalletFloatingHeader;